import axios from 'axios';
import {
  buildProjectAdminLandingPath,
  resolveCapabilities,
} from '../pages/superadmin-shell/superAdminTabs';

function getAuthToken(explicitToken) {
  if (explicitToken) return explicitToken;
  try {
    return localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  } catch {
    return '';
  }
}

/**
 * После логина project admin — URL первого доступного таба (с учётом ACL).
 * При ошибке API — /admin без query; shell нормализует URL после загрузки caps.
 */
export async function resolveProjectAdminLandingPath(
  projectSlug,
  { role = 'admin', token } = {},
) {
  if (!projectSlug) return '/';
  const authToken = getAuthToken(token);
  if (!authToken) return `/p/${encodeURIComponent(projectSlug)}/admin`;
  try {
    const res = await axios.get(
      `${window.location.origin}/api/p/${encodeURIComponent(projectSlug)}/auth/capabilities`,
      { headers: { Authorization: `Bearer ${authToken}` } },
    );
    const caps = resolveCapabilities({ role, serverCapabilities: res?.data });
    return buildProjectAdminLandingPath(projectSlug, {
      scope: 'project',
      role,
      capabilities: caps,
    });
  } catch {
    return `/p/${encodeURIComponent(projectSlug)}/admin`;
  }
}
